<template>
  <div :class="modal ? 'modal-card' : ''">
    <div v-if="modal" class="modal-card-head" />
    <div :class="modal ? 'modal-card-body' : ''">
      <div :class="quick ? '' : 'box'">
        <!--<b-message
          v-if="question.open_time"
          type="is-primary"
        >
          {{ $t('questionNotEditableAnymore') }}
        </b-message>-->
        <b-field grouped>
          <b-input v-model="question.question" class="mb-3" expanded :placeholder="$t('typeQuestionHere')" />
          <!--<b-field 
            type="is-primary"
            :label="$t('surveyMethod')"
          >
            <b-select 
              v-model="question.type"
              @input="setQuestion(question.type, key)"
            >
              <option value="surveySelect">
                {{ $t('surveySelect') }} 
              </option>
              <option value="surveyStars">
                {{ $t('surveyStars') }} 
              </option>
              <option value="surveyRunOff">
                {{ $t('surveyRunOff') }} 
              </option>
            </b-select>
          </b-field>-->
        </b-field>
        <div v-if="question.type == 'surveySelect' || question.type == 'surveySimple'">
          <!--<b-field v-else>
            <b-message
              type="is-primary"              
            >
              {{ $t('surveyRunOffExplained') }}
            </b-message>
          </b-field>-->

          <form ref="form">
            <div v-for="(option, key2) in question.options" :key="key2">
              <b-field>
                <b-input
                  v-model="option.text"
                  :placeholder="$t('typeOptionHere')"
                  class="mb-4"
                  expanded
                  :required="key2 == question.options.length - 1 ? false : true"
                  @input="
                    key2 == question.options.length - 1 &&
                    question.options.length < 9 &&
                    question.type != 'surveySimple'
                      ? addQuestionOption(question.options.length)
                      : ''
                  "
                />
                <p class="mb-4 control">
                  <b-button
                    v-if="question.type != 'surveySimple' && !quick"
                    :disabled="question.options.length <= 2"
                    type="is-danger"
                    icon-left="delete"
                    @click="removeQuestionOption(key2)"
                  />
                </p>
              </b-field>
            </div>
          </form>
          <b-field v-if="question.abstain">
            <b-input :value="$t('abstain')" readonly />
          </b-field>
          <b-field v-if="question.type != 'surveySimple'" :label="$t('selectableAnswers')" />
          <b-field class="mb-4" grouped group-multiline>
            <b-numberinput
              v-if="question.type != 'surveySimple'"
              v-model="question.selectable"
              expanded
              :min="1"
              :max="question.options.length"
            />
            <b-button
              v-if="!quick"
              class="control"
              type="is-danger"
              :disabled="questions.length <= 1 || question.open_time"
              @click="removeQuestion(questionKey)"
            >
              {{ $t("removeQuestion") }}
            </b-button>
          </b-field>
          <b-field :label="$t('options')" />
          <div>
            <div class="table">
              <tr>
                <td>
                  <b-field :label="$t('abstainPossible')" />
                </td>
                <td>
                  <b-switch
                    v-model="question.abstain"
                    @click.native="question.abstain ? (question.showAbstainBig = false) : ''"
                  >
                    {{ question.abstain ? $t("Yes") : $t("No") }}
                  </b-switch>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :label="$t('showAbstainBig')" />
                </td>
                <td>
                  <b-switch
                    v-model="question.showAbstainBig"
                    @click.native="question.showAbstainBig ? '' : (question.abstain = true)"
                  >
                    {{ question.showAbstainBig ? $t("Yes") : $t("No") }}
                  </b-switch>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :label="$t('timingExplained')" />
                </td>
                <td>
                  <b-switch v-model="question.timed">
                    {{ question.timed ? $t("Yes") : $t("No") }}
                  </b-switch>
                </td>
              </tr>
              <div v-if="question.timed">
                <b-slider
                  v-model.lazy="question.duration"
                  class="py-3"
                  :min="30"
                  :max="300"
                  expanded
                  tooltip
                  :custom-formatter="(val) => Math.floor(val / 60) + ' Minute(n), ' + val + 's'"
                >
                  <template v-for="val in [60, 120, 180, 240, 300]">
                    <b-slider-tick :key="val" :value="val"> {{ val }}s </b-slider-tick>
                  </template>
                </b-slider>
                <b-numberinput v-model="question.duration" class="py-3" :min="30" :max="300" />
              </div>
              <tr>
                <td><b-field :label="$t('showResults')" /></td>
                <td>
                  <b-switch
                    v-model="question.showResults"
                    @click.native="question.showResults ? '' : (question.onlyFinalResults = false)"
                  >
                    {{ question.showResults ? $t("Yes") : $t("No") }}
                  </b-switch>
                </td>
              </tr>
              <tr>
                <td><b-field :label="$t('onlyFinalResults')" /></td>
                <td>
                  <b-switch
                    v-model="question.onlyFinalResults"
                    @click.native="question.onlyFinalResults ? '' : (question.showResults = false)"
                  >
                    {{ question.onlyFinalResults ? $t("Yes") : $t("No") }}
                  </b-switch>
                </td>
              </tr>
              <tr v-if="false">
                <td><b-field :label="$t('personalization')" /></td>
                <td>
                  <b-switch v-model="question.personalization">
                    {{ question.timed ? $t("Yes") : $t("No") }}
                  </b-switch>
                </td>
              </tr>
              <div v-if="question.personalization && false">
                <b-select>
                  <div />
                </b-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modal" class="modal-card-foot">
      <b-button
        :loading="isLoading"
        :disabled="isDisabled"
        type="is-info"
        class=""
        icon-left="content-save-outline"
        @click="saveQuestion"
      >
        {{ $t("saveChanges") }}
      </b-button>
      <b-button
        :loading="isLoading"
        :disabled="isDisabled"
        type="is-danger"
        class=""
        icon-left="close"
        @click="$parent.close()"
      >
        {{ $t("close") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { functions } from "@/firebase";
export default {
  name: "EditQuestion",
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    questions: {
      type: Array,
      default() {
        return [];
      },
    },
    questionKey: {
      type: Number,
      default() {
        return 0;
      },
    },
    quick: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    surveyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isDisabled: false,
      isLoading: false,
    };
  },
  watch: {
    question: {
      deep: true,
      handler() {
        this.isDisabled = !this.$refs.form.checkValidity();
      },
    },
  },
  mounted() {
    console.log("awda");
    if (this.modal && this.question.type != "surveySimple") {
      console.log("#awdad");
      this.addQuestionOption(this.question.options.length);
    }
  },
  methods: {
    removeQuestionOption(optionKey) {
      this.$delete(this.question.options, optionKey);
      if (this.question.options.length < this.question.selectable) {
        this.question.selectable = this.question.options.length;
      }
    },
    addQuestionOption(optionKey) {
      this.$set(this.question.options, optionKey, { text: "", _sortId: v4() });
    },
    removeQuestion(questionKey) {
      this.$delete(this.questions, questionKey);
      if (this.questions.length < 1) {
        this.addQuestion();
      }
    },
    async saveQuestion() {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        await functions.httpsCallable("EditQuestion")({
          question: this.question,
          questionKey: this.questionKey.toString(),
          surveyId: this.surveyId,
          moderationPw: this.$route.params.moderationPw,
        });
        this.$parent.close();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.toString(),
          type: "is-danger",
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style></style>
